export default {
  blogs: {
    name: 'บทความ',
    fields: {
      title_th: 'หัวข้อบทความ (ไทย)',
      title_en: 'หัวข้อบทความ (อังกฤษ)',
      title: 'หัวข้อบทความ (ไทย/อังกฤษ)',
      description_th: 'เนื้อหาบทความ (ไทย)',
      description: 'เนื้อหาบทความ',
      description_en: 'เนื้อหาบทความ (อังกฤษ)',
      short_description_th: 'เนื้อหาบทความโดยย่อ (ไทย)',
      short_description: 'เนื้อหาบทความโดยย่อ',
      short_description_en: 'เนื้อหาบทความโดยย่อ (อังกฤษ)',
      start: { title: 'เริ่มต้น' },
      end: { title: 'สิ้นสุด' },
      type: { label: 'ประเภท', choices: { common: 'ส่วนกลาง', branch: 'สาขา' } },
      attachment_helper: 'อนุญาตเฉพาะไฟล์สกุล pdf ขนาดไม่เกิน 5mb สูงสุด 15 ไฟล์',
      attachment: 'ไฟล์แนบ',
      thumbnail_path: 'ภาพตัวอย่าง',
      thumbnail_helper: 'อนุญาตเฉพาะไฟล์สกุล jpg, png, jpeg ขนาดไม่เกิน 2mb',
      thumbnail_path_helper: 'รูปภาพตัวอย่าง',
      cover: 'รูปภาพพื้นหลัง',
      cover_helper: 'อนุญาตเฉพาะไฟล์สกุล jpg, png, jpeg ขนาดไม่เกิน 2mb',
      notification: 'แจ้งเตือน',
      // note: 'คอนเทนท์ของคุณจะยังไม่ถูกเผยแพร่จนกว่าจะได้รับการอนุมัติ',
      note: '',
      no_image: 'ไม่มีภาพตัวอย่าง',
      images: 'รูปภาพประกอบ',
      images_helper: 'อนุญาตเฉพาะไฟล์สกุล jpg, png, jpeg ขนาดไม่เกิน 2mb สูงสุด 15 ไฟล์'
    },
    create: { title: 'สร้างบทความ' },
    edit: { title: 'แก้ไขบทความ' },
    order: { title: 'จัดการลำดับบทความ' },
    approved: { title: 'บทความที่อนุมัติ' },
    published: { title: 'บทความที่เผยแพร่' },
    highlight: {
      title: 'บทความเด่น',
      choices: {
        true: 'บทความเด่น',
        false: 'บทความไม่เด่น',
      }
    },
    viewer: {
      guest: 'ผู้ใช้ทั่วไป',
      branch: 'name_th',
      from: 'ผู้เข้าชมจาก',
      views: 'จำนวนผู้เข้าชม',
      all_views: 'ยอดเข้าชมทั้งหมด',
    },
  },
}
